module.exports = __webpack_public_path__ + "static/media/panda-partners-2.c9e1172d.svg";